import MenuItemType from "components/Editorial/ActionsMenu/PropTypes/MenuItemType";
import React from "react";
import { mapKeys } from "lodash";
import { track } from "lib/analytics";

const GOOGLE_ANALYTICS_CATEGORY = "Editorial Menu";
const GOOGLE_ANALYTICS_ACTION = "Click";

export default function MenuItem({
  item: {
    classNames,
    dataAttributes,
    icon,
    label,
    trackAction,
    url,
  },
}) {
  const anchorDataAttributes = mapKeys(dataAttributes, (value, key) => `data-${key}`);

  return (
    <li>
      <a
        href={url}
        className={classNames}
        onMouseDown={() => track(GOOGLE_ANALYTICS_CATEGORY, GOOGLE_ANALYTICS_ACTION, trackAction)}
        {...anchorDataAttributes}
      >
        <i className={`icon-${icon}`} />&nbsp;
        {label}
      </a>
    </li>
  );
}

MenuItem.propTypes = {
  item: MenuItemType.isRequired,
};
